
import mx from "mxgraph"
//var mx = require('mxgraph')

const mxgraph = mx({
    mxImageBasePath: '/script/mxgraph-source/images',
    mxBasePath: '/script/mxgraph-source'
});
// decode bug https://github.com/jgraph/mxgraph/issues/49
window.mxGraph = mxgraph.mxGraph;
window.mxGraphModel = mxgraph.mxGraphModel;
window.mxEditor = mxgraph.mxEditor;
window.mxGeometry = mxgraph.mxGeometry;
window.mxDefaultKeyHandler = mxgraph.mxDefaultKeyHandler;
window.mxDefaultPopupMenu = mxgraph.mxDefaultPopupMenu;
window.mxStylesheet = mxgraph.mxStylesheet;
window.mxDefaultToolbar = mxgraph.mxDefaultToolbar;
window.mxStencilRegistry = mxgraph.mxStencilRegistry;
window.mxStencil = mxgraph.mxStencil;
window.mxConnectionHandler = mxgraph.mxConnectionHandler
window.mxImage = mxgraph.mxImage;
window.mxToolbar = mxgraph.mxToolbar;
window.mxKeyHandler = mxgraph.mxKeyHandler;
window.mxGraphHandler = mxgraph.mxGraphHandler;
window.mxCellTracker = mxgraph.mxCellTracker;
window.mxRubberband = mxgraph.mxRubberband;
window.mxOutline = mxgraph.mxOutline;
window.mxCell = mxgraph.mxCell;
window.mxEdgeStyle = mxgraph.mxEdgeStyle;
window.mxShape = mxgraph.mxShape;
window.mxConnectionConstraint = mxgraph.mxConnectionConstraint;
window.mxPoint = mxgraph.mxPoint
window.mxEvent = mxgraph.mxEvent
window.mxObjectCodec = mxgraph.mxObjectCodec
window.mxGuide = mxgraph.mxGuide
window.mxEdgeHandler = mxgraph.mxEdgeHandler
window.mxWindow = mxgraph.mxWindow
window.mxEffects = mxgraph.mxEffects
window.mxSwimlaneManager = mxgraph.mxSwimlaneManager
window.mxStackLayout = mxgraph.mxStackLayout
window.mxLayoutManager = mxgraph.mxLayoutManager
window.mxSwimlane = mxgraph.mxSwimlane
window.mxSwimlaneLayout = mxgraph.mxSwimlaneLayout
window.mxStyleRegistry = mxgraph.mxStyleRegistry
window.mxMarker = mxgraph.mxMarker
window.mxArrow = mxgraph.mxArrow
window.mxCellRenderer = mxgraph.mxCellRenderer
window.mxCylinder = mxgraph.mxCylinder
window.mxClipboard = mxgraph.mxClipboard
window.mxConstants = mxgraph.mxConstants
window.mxEventObject = mxgraph.mxEventObject
window.mxDragSource = mxgraph.mxDragSource
export default mxgraph;